// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h5[data-v-73920ecc] {\n  color: #91295a;\n  margin-bottom: 1rem;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
